import { promises } from "config/algolia";

const DEFAULT_LENGTH = 10;
export const getPromises = async ({
  filters = "",
  searchText = "",
  length = DEFAULT_LENGTH,
  offset = 0,
}) => {
  const result = await promises.search(searchText, {
    filters,
    length,
    page: offset,
    hitsPerPage: length,
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>",
  });
  return {
    hits: result.hits,
    hitsLength: result.nbHits,
  };
};

export const getRelatedPromises = async ({
  title = "",
  currentId = "",
  length = 8,
}) => {
  if (!title) return [];
  try {
    const trimmedTitle = title.trim();
    const result = await promises.search(trimmedTitle, {
      optionalWords: trimmedTitle,
      removeWordsIfNoResults: "allOptional",
      hitsPerPage: length + 2,
    });

    return result.hits
      .filter((item) => (item.objectID || item.id) !== currentId)
      .slice(0, length)
      .map((item) => ({
        ...item,
        id: item.objectID || item.id,
        predictor:
          item.predictor ||
          (item["predictor.firstName"] || item["predictor.lastName"]
            ? {
                id: item["predictor.id"] || item["predictor.objectID"],
                firstName: item["predictor.firstName"] || "",
                lastName: item["predictor.lastName"] || "",
                image: item["predictor.image"] || "",
              }
            : null),
      }));
  } catch (error) {
    console.error("Error in getRelatedPromises:", error);
    return [];
  }
};
